import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus, gql } from '@apollo/client'
import MapCluster, { EventCartChangeData } from '../../../components/map/MapCluster'
import CardWidgetSkeleton from '../../../components/skeletons/CardWidgetSkeleton'
import { CartChangeFiltersContext } from '../../../context/CartChangeFiltersContext'
// import { GET_EVENTS_MAPS } from '../../../../queries/Cart'

const GET_EVENTS_MAPS = gql`
  query EventsMaps($filters: EventCartChangeFilter) {
    eventCartChangeAggs(
      filters: $filters,
      index: "eventos-fapp-cart-change-*",
      size: 0,
      query: {
        bool: {
          filter: {
            geo_distance: {
              distance: "4000km",
              geoip_location: {
                lat: -23.533773,
                lon: -46.62529
              }
            }
          }
        }
      },
      aggs: {
        locations: {
          geohash_grid: {
            field: "geoip.location",
            precision: 3
          }
        }
      }
    ) {
      aggregations
    }
  }
`

const MapEvents = (): JSX.Element => {
  const { filters } = useContext(CartChangeFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_EVENTS_MAPS, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.eventCartChangeAggs.aggregations.locations.buckets) return <p>No data found :(</p>

  const bucketsData: EventCartChangeData[] = data.eventCartChangeAggs.aggregations.locations.buckets

  return (
    <MapCluster data={bucketsData} />
  )
}

export default MapEvents
